module.exports = __webpack_public_path__ + "img/delivery.d0600b31.svg";